"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageBannerComponent = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const icon_1 = require("../icon");
const icons_1 = require("../icon/icons");
const mithril_component_1 = require("../mithril.component");
const message_banner_style_1 = require("./message.banner.style");
class MessageBannerComponent extends mithril_component_1.IMithrilComponent {
    constructor() {
        super();
        this.name = 'MessageBanner';
        this.bannerVisible = false;
    }
    get nodes() {
        if (this.bannerVisible) {
            return (0, mithril_1.m)('div', { className: message_banner_style_1.CSS.alert }, [
                (0, mithril_1.m)('span', { className: message_banner_style_1.CSS.message }, [
                    (0, i18n_1.Translate)(i18n_1.T.BANNER_MESSAGE_PT1),
                    (0, mithril_1.m)('a', { className: message_banner_style_1.CSS.alertHref, href: 'https://ikegps.com/support/sso-for-ike/', target: '_blank' }, (0, i18n_1.Translate)(i18n_1.T.HERE)),
                    (0, i18n_1.Translate)(i18n_1.T.BANNER_MESSAGE_PT2),
                ]),
                (0, mithril_1.m)('button', {
                    className: message_banner_style_1.CSS.closeButton,
                    onclick: () => {
                        this.bannerVisible = false;
                    },
                    title: i18n_1.T.CLOSE,
                }, [
                    (0, i18n_1.Translate)(i18n_1.T.DISMISS),
                    icon_1.Icon.view(icons_1.MaterialIcon.CLOSE, {
                        className: message_banner_style_1.CSS.closeIcon,
                    }),
                ]),
            ]);
        }
        return null;
    }
}
exports.MessageBannerComponent = MessageBannerComponent;
tslib_1.__decorate([
    mobx_1.observable
], MessageBannerComponent.prototype, "bannerVisible", void 0);
tslib_1.__decorate([
    mobx_1.computed
], MessageBannerComponent.prototype, "nodes", null);
//# sourceMappingURL=message.banner.js.map